/**
 This config file is used to set up the broad app configuration and expose environment variables to the code.
 See /docs/ConfigurationManagement.md for more details.
 */

export type AppConfig = {
  isDevelopmentMode: boolean;
  apiBaseEndpoint: string;
  medrecruitWebBaseUrl: string;
  mixpanel: {
    token: string;
  };
  sentry: {
    dsn: string;
    env: string;
  };
  feedback: {
    email: string;
  };
  split: {
    clientKey: string;
    localhostMode: boolean;
  };
  oneFlow: {
    projectKey: string;
  };
  apiVersion: number;
};

export const appConfig: AppConfig = {
  isDevelopmentMode: import.meta.env.MODE === 'development',
  apiBaseEndpoint: import.meta.env.VITE_API_BASE_ENDPOINT ?? '',
  medrecruitWebBaseUrl: import.meta.env.VITE_MEDRECRUIT_WEB_BASE_URL ?? '',
  mixpanel: {
    token: import.meta.env.VITE_MIXPANEL_TOKEN ?? '',
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN ?? '',
    env: import.meta.env.MODE === 'development' ? 'local' : (import.meta.env.VITE_SENTRY_ENVIRONMENT ?? ''),
  },
  feedback: {
    email: 'feedback@medworld.com',
  },
  split: {
    clientKey: import.meta.env.VITE_SPLIT_CLIENT_KEY ?? '',
    localhostMode: import.meta.env.VITE_SPLIT_LOCALHOST_MODE === 'true',
  },
  oneFlow: {
    projectKey: import.meta.env.VITE_ONE_FLOW_PROJECT_KEY ?? '',
  },
  apiVersion: 10,
};
